import type { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { updateUserConsultStyleApi, updateUserInfoApi, withdrawalApi } from '@/api/userApi'
import type {
  UpdateUserConsultStyleBody,
  UpdateUserConsultStyleResponse,
  UpdateUserInfoBody,
  UpdateUserInfoResponse,
  WithdrawalResponse,
  WithdrawalBody
} from '@/api/model/userType'

export const useUpdateUserInfoMutation = (
  options: UseMutationOptions<UpdateUserInfoResponse, AxiosError, { user_id: number; body: UpdateUserInfoBody }>
) => {
  return useMutation({
    mutationFn: ({ user_id, body }: { user_id: number; body: UpdateUserInfoBody }) => updateUserInfoApi(user_id, body),
    ...options
  })
}

export const useUpdateUserConsultStyleMutation = (
  options: UseMutationOptions<
    UpdateUserConsultStyleResponse,
    AxiosError,
    { user_id: number; body: UpdateUserConsultStyleBody }
  >
) => {
  return useMutation({
    mutationFn: ({ user_id, body }: { user_id: number; body: UpdateUserConsultStyleBody }) =>
      updateUserConsultStyleApi(user_id, body),
    ...options
  })
}

export const useWithdrawalMutation = (
  options: UseMutationOptions<WithdrawalResponse, AxiosError, { user_id: number; body: WithdrawalBody }>
) => {
  return useMutation({
    mutationFn: ({ user_id, body }: { user_id: number; body: WithdrawalBody }) => withdrawalApi(user_id, body),
    ...options
  })
}
